// -- UTILITY-FUNCTIONS --
// A worm (or any {centerX, centerY, radius} without a type) is treated as a circle.
// The engine asks this for every worm and segment many times a tick, so the circle is
// written into one of two reusable objects instead of a fresh one (plus its bounding
// box) per call. Safe because no relation function keeps a shape or calls back here.
function createScratchCircle() {
    return {type: "circle", centerX: 0, centerY: 0, x: 0, y: 0, maxX: 0, maxY: 0, radius: 0, boundingBox: {width: 0, height: 0}};
}
var scratchShape = createScratchCircle();
var scratchOtherShape = createScratchCircle();
function wormAsCircle(w, out) {
    out.centerX = w.centerX;
    out.centerY = w.centerY;
    out.x = w.centerX - w.radius;
    out.y = w.centerY - w.radius;
    out.maxX = w.centerX + w.radius;
    out.maxY = w.centerY + w.radius;
    out.radius = w.radius;
    out.boundingBox.width = w.radius * 2;
    out.boundingBox.height = w.radius * 2;
    return out;
}

function isRelationTrue(spatialRelationsFunctions, shape, otherShape) {
    // TODO Not the prettiest but works for now. This handles special worm treatment
    if (!shape.type) {
        shape = wormAsCircle(shape, scratchShape);
    }

    if(!otherShape.type) {
        otherShape = wormAsCircle(otherShape, scratchOtherShape);
    }

    return spatialRelationsFunctions[shape.type][otherShape.type](shape, otherShape);
}

function boundingBoxesIntersects(shape, otherShape) {
    var distX = Math.abs(shape.centerX - otherShape.centerX);
    var distY = Math.abs(shape.centerY - otherShape.centerY);

    var minBoundingDistX = shape.boundingBox.width / 2 + otherShape.boundingBox.width / 2;
    var minBoundingDistY = shape.boundingBox.height / 2 + otherShape.boundingBox.height / 2;

    return !(distX > minBoundingDistX || distY > minBoundingDistY);
}

function boundingBoxesContains(outerShape, innerShape) {
    var distX = Math.abs(outerShape.centerX - innerShape.centerX) + innerShape.boundingBox.width / 2;
    var distY = Math.abs(outerShape.centerY - innerShape.centerY) + innerShape.boundingBox.height / 2;

    return distX < outerShape.boundingBox.width / 2 && distY < outerShape.boundingBox.height / 2;
}

function createShapeRelationMatrix() {
    var matrix = [];
    matrix["circle"] = [];
    matrix["rectangle"] = [];
    matrix["stadium"] = [];
    return matrix;
}

// Distance from a point to a stadium's spine (the segment its radius is measured
// from): the point is inside the stadium when this is under the radius.
function stadiumSpineDistance(stadium, px, py) {
    var dx = Math.max(0, Math.abs(px - stadium.centerX) - stadium.halfSpine);
    var dy = py - stadium.centerY;
    return Math.sqrt(dx * dx + dy * dy);
}

// -- INTERSECTION-FUNCTIONS --
var intersectsFunctions = createShapeRelationMatrix();

intersectsFunctions["circle"]["circle"] = function circleCircleIntersection(circle, otherCircle) {
    if (!boundingBoxesIntersects(circle, otherCircle)) {
        return false;
    }

    var maxAllowedDist = circle.radius + otherCircle.radius;

    return distanceSquared(circle, otherCircle) < maxAllowedDist * maxAllowedDist;
};

intersectsFunctions["rectangle"]["rectangle"] = function rectangleRectangleIntersection(rectangle, otherRectangle) {
    return boundingBoxesIntersects(rectangle, otherRectangle);
};

intersectsFunctions["circle"]["rectangle"] = function circleRectangleIntersection(circle, rectangle) {
    if (!boundingBoxesIntersects(circle, rectangle)) {
        return false;
    }

    var distX = Math.abs(circle.centerX - rectangle.centerX);
    var distY = Math.abs(circle.centerY - rectangle.centerY);

    //The following 2 checks are only valid because of prior checking of the bounding boxes
    if (distX <= (rectangle.width / 2)) {
        return true;
    }
    if (distY <= (rectangle.height / 2)) {
        return true;
    }

    // special case for rectangle corners
    var cornerDistX = distX - rectangle.width / 2;
    var cornerDistY = distY - rectangle.height / 2;
    var cornerDistanceSq = cornerDistX*cornerDistX + cornerDistY*cornerDistY;

    return cornerDistanceSq <= circle.radius * circle.radius;
};

intersectsFunctions["rectangle"]["circle"] = function rectangleCircleIntersection(rectangle, circle) {
    return intersectsFunctions["circle"]["rectangle"](circle, rectangle);
};


// -- CONTAINMENT-FUNCTIONS
var containmentFunctions = createShapeRelationMatrix();

containmentFunctions["circle"]["circle"] = function circleCircleContainment(outerCircle, innerCircle) {
    if (!boundingBoxesContains(outerCircle, innerCircle)) {
        return false;
    }

    var maxAllowedDist = outerCircle.radius - innerCircle.radius;

    return distanceSquared(outerCircle, innerCircle) < maxAllowedDist * maxAllowedDist;
};

containmentFunctions["rectangle"]["rectangle"] = function rectangleRectangleContainment(outerRectangle, innerRectangle) {
    return boundingBoxesContains(outerRectangle, innerRectangle);
};

containmentFunctions["circle"]["rectangle"] = function circleRectangleContainment(outerCircle, innerRectangle) {
    if (!boundingBoxesContains(outerCircle, innerRectangle)) {
        return false;
    }

    //here we select the rectangles corner point furthest away from the circle center
    var distX = Math.max(Math.abs(outerCircle.centerX - innerRectangle.x), Math.abs(outerCircle.centerX - innerRectangle.maxX));
    var distY = Math.max(Math.abs(outerCircle.centerY - innerRectangle.y), Math.abs(outerCircle.centerY - innerRectangle.maxY));

    return distX*distX + distY*distY <= outerCircle.radius*outerCircle.radius;
};

containmentFunctions["rectangle"]["circle"] = function rectangleCircleContainment(outerRectangle, innerCircle) {
    return boundingBoxesContains(outerRectangle, innerCircle);
};

// -- STADIUM --
intersectsFunctions["stadium"]["circle"] = function stadiumCircleIntersection(stadium, circle) {
    if (!boundingBoxesIntersects(stadium, circle)) {
        return false;
    }
    return stadiumSpineDistance(stadium, circle.centerX, circle.centerY) < stadium.radius + circle.radius;
};
intersectsFunctions["circle"]["stadium"] = function circleStadiumIntersection(circle, stadium) {
    return intersectsFunctions["stadium"]["circle"](stadium, circle);
};
intersectsFunctions["stadium"]["rectangle"] = function stadiumRectangleIntersection(stadium, rectangle) {
    if (!boundingBoxesIntersects(stadium, rectangle)) {
        return false;
    }
    // the rectangle's point nearest the spine: clamp the spine's nearest x, then y
    var sx = Math.min(Math.max(stadium.centerX, rectangle.x), rectangle.maxX);
    sx = Math.min(Math.max(sx, stadium.centerX - stadium.halfSpine), stadium.centerX + stadium.halfSpine);
    var nx = Math.min(Math.max(sx, rectangle.x), rectangle.maxX);
    var ny = Math.min(Math.max(stadium.centerY, rectangle.y), rectangle.maxY);
    return stadiumSpineDistance(stadium, nx, ny) <= stadium.radius;
};
intersectsFunctions["rectangle"]["stadium"] = function rectangleStadiumIntersection(rectangle, stadium) {
    return intersectsFunctions["stadium"]["rectangle"](stadium, rectangle);
};
intersectsFunctions["stadium"]["stadium"] = function stadiumStadiumIntersection(stadium, otherStadium) {
    // (never two stadiums in play today: a bounding-box answer is enough)
    return boundingBoxesIntersects(stadium, otherStadium);
};

containmentFunctions["stadium"]["circle"] = function stadiumCircleContainment(stadium, circle) {
    if (!boundingBoxesContains(stadium, circle)) {
        return false;
    }
    return stadiumSpineDistance(stadium, circle.centerX, circle.centerY) < stadium.radius - circle.radius;
};
containmentFunctions["stadium"]["rectangle"] = function stadiumRectangleContainment(stadium, rectangle) {
    if (!boundingBoxesContains(stadium, rectangle)) {
        return false;
    }
    // convex: inside when all four corners are
    return stadiumSpineDistance(stadium, rectangle.x, rectangle.y) <= stadium.radius &&
        stadiumSpineDistance(stadium, rectangle.maxX, rectangle.y) <= stadium.radius &&
        stadiumSpineDistance(stadium, rectangle.x, rectangle.maxY) <= stadium.radius &&
        stadiumSpineDistance(stadium, rectangle.maxX, rectangle.maxY) <= stadium.radius;
};
containmentFunctions["stadium"]["stadium"] = function stadiumStadiumContainment(stadium, otherStadium) {
    return boundingBoxesContains(stadium, otherStadium);
};
containmentFunctions["circle"]["stadium"] = function circleStadiumContainment(circle, stadium) {
    // the stadium's farthest points from the circle's centre are on its end circles
    var ends = [stadium.centerX - stadium.halfSpine, stadium.centerX + stadium.halfSpine];
    for (var i = 0; i < ends.length; i++) {
        var dx = ends[i] - circle.centerX, dy = stadium.centerY - circle.centerY;
        if (Math.sqrt(dx * dx + dy * dy) + stadium.radius > circle.radius) {
            return false;
        }
    }
    return true;
};
containmentFunctions["rectangle"]["stadium"] = function rectangleStadiumContainment(rectangle, stadium) {
    return boundingBoxesContains(rectangle, stadium);
};

function intersects(shape, otherShape) {
    return isRelationTrue(intersectsFunctions, shape, otherShape);
}

function contains(outerShape, innerShape) {
    return isRelationTrue(containmentFunctions, outerShape, innerShape);
}

function distanceSquared(shape, otherShape) {
    var distX = Math.abs(shape.centerX - otherShape.centerX);
    var distY = Math.abs(shape.centerY - otherShape.centerY);
    return distX * distX + distY * distY;
}

function distance(shape, otherShape) {
    return Math.sqrt(distanceSquared(shape, otherShape));
}

export {
    intersects,
    contains,
    distance,
    distanceSquared,
    stadiumSpineDistance
}


